import { SVGProps } from 'react'

export const LogoBrighter = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="37"
      height="26"
      viewBox="0 0 37 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
   <defs>
      <linearGradient
        id="a"
        x1={25.24}
        y1={14.6}
        x2={25.24}
        y2={-103.5}
        gradientTransform="matrix(.86 -.24 0 .46 6.53 55.37)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#f0f3ff" />
        <stop offset={1} stopColor="#b6b6b6" />
      </linearGradient>
      <linearGradient
        id="b"
        x1={25.24}
        y1={14.02}
        x2={25.24}
        y2={-103.47}
        gradientTransform="matrix(.86 -.24 0 .46 6.53 55.37)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#fff" />
        <stop offset={1} stopColor="#b3b3b3" />
      </linearGradient>
    </defs>
    <title>{"portalwAsset 2"}</title>
    <g data-name="Layer 2">
      <g data-name="Layer 1">
        <path
          d="M28.66 1.52a35.24 35.24 0 0 0-9.55 4.86c-8.18 6-11.58 13-14.15 19.32.89-3.77.7-4.31 3.84-11C-.51 26.77-2.59 39.37 3.31 48.5c2.52 3.9 6.9 7.1 13.73 8.12l.61.08a31.54 31.54 0 0 0 17-3.2 37.47 37.47 0 0 0 14.66-13.23c7.84-11.89 9.83-25.42 2.81-33.86C49.4 3.15 45 .25 38.21 0a28.09 28.09 0 0 0-9.55 1.52Zm21.11 19.14a23.45 23.45 0 0 1-1.19 10.82 48 48 0 0 1-3.73 7.45c-2.23 3.22-7.07 7.72-12.5 9.22a18.09 18.09 0 0 1-10.86-.3c-2-.72-5-2-5.64-3.59 2.22 5.73 11.31 9.37 23 3.86a11.43 11.43 0 0 1-4.21 3 29.44 29.44 0 0 1-10 2.23c-2.76-.06-8.3-1-11.19-4.55S9.29 40 9.11 36.79s.37-9.78 2-13.15 4.45-8.19 7-10.73c4.59-4.6 7.29-5.55 10-6.53s7.5-1.11 10.4.9c4.87 3.36 7.87 8.51 6.68 14.25a15.12 15.12 0 0 0-.91-11.83 19.31 19.31 0 0 0-1.18-2 13.7 13.7 0 0 1 4.21 4.3 33.68 33.68 0 0 1 2.46 8.66Z"
          style={{
            fill: "url(#a)",
          }}
        />
        <path
          d="M52.12 6.42C49.4 3.15 45 .25 38.22 0a28.11 28.11 0 0 0-9.56 1.51c-.39.12-.78.26-1.17.4a35.19 35.19 0 0 0-8.38 4.46c-8.18 6-11.58 13-14.15 19.32.89-3.77.7-4.31 3.84-11C-.51 26.77-2.59 39.37 3.31 48.5c2.51 3.9 6.9 7.1 13.73 8.11l.61.09a30.53 30.53 0 0 0 13.91-1.86 33.09 33.09 0 0 0 3.13-1.34 37.54 37.54 0 0 0 14.62-13.23c7.84-11.89 9.83-25.42 2.81-33.85ZM6.31 47.17a20 20 0 0 1-3.14-11 21.06 21.06 0 0 1 1.24-5.38 24 24 0 0 1 3.05-5.3A39.68 39.68 0 0 0 6 37.65a23.56 23.56 0 0 0 4.6 12.59A13.71 13.71 0 0 0 17 54.3a16.69 16.69 0 0 1-10.69-7.13Zm43.46-26.51a23.45 23.45 0 0 1-1.19 10.82 48 48 0 0 1-3.73 7.45 25.77 25.77 0 0 1-11.18 8.8c-.44.16-.87.3-1.32.42a18.17 18.17 0 0 1-10.86-.3c-2-.72-5-2-5.64-3.59 2 5.3 10 8.81 20.45 5a28 28 0 0 0 2.58-1.09 11.43 11.43 0 0 1-4.21 3l-1 .39a28.83 28.83 0 0 1-9 1.84c-2.76-.06-8.3-1-11.19-4.55S9.29 40 9.11 36.79s.37-9.78 2-13.15 4.45-8.19 7-10.73c4.22-4.23 6.84-5.37 9.33-6.29l.65-.23c2.7-1 7.5-1.11 10.4.89 4.87 3.36 7.87 8.52 6.68 14.25a15.12 15.12 0 0 0-.89-11.83 19.31 19.31 0 0 0-1.18-2 15.13 15.13 0 0 1 3.9 4.41 34.64 34.64 0 0 1 2.77 8.55Zm3.35 2.25a18.44 18.44 0 0 0-.2-3.22 35.37 35.37 0 0 0-2.56-8.89 11.88 11.88 0 0 0-2.73-3.35c-.35-.29-.72-.57-1.13-.85a20 20 0 0 0-10-2.87h-2.63a18.89 18.89 0 0 0-6.45 1h-.1l-.5.27c-3 1.12-6.39 2.61-11.21 7.44a22.69 22.69 0 0 0-1.56 1.76 33.63 33.63 0 0 1 7-6.86 30 30 0 0 1 7-3.74l1-.33a23.73 23.73 0 0 1 6-1.19h.25a20 20 0 0 1 5.82.56 4.34 4.34 0 0 1 .79.32 15.91 15.91 0 0 1 7.23 4.92c3.31 3.88 4.6 9.17 3.98 15.03Z"
          style={{
            fill: "url(#b)",
          }}
        />
      </g>
    </g>
    </svg>
  )
}
